import { I18N_NAMESPACE } from "../../../common/constants/i18n"

export const EQUIPMENT_CONDITION_GOOD = 10
export const EQUIPMENT_CONDITION_MEDIUM = 20
export const EQUIPMENT_CONDITION_BAD = 30
export const EQUIPMENT_CONDITION_UNKNOWN = -1
export const EQUIPMENT_CONDITIONS = [
    EQUIPMENT_CONDITION_GOOD,
    EQUIPMENT_CONDITION_MEDIUM,
    EQUIPMENT_CONDITION_BAD,
    EQUIPMENT_CONDITION_UNKNOWN,
]

export const getEquipmentConditionsValues = (t, theme) => ({
    [EQUIPMENT_CONDITION_BAD]: {
        backgroundColor: theme.palette["red/100"]?.main,
        labelColor: theme.palette["error"]?.main,
        color: theme.palette["error"]?.main,
        label: t(I18N_NAMESPACE, "components.equipmentConditionCount.bad"),
    },
    [EQUIPMENT_CONDITION_MEDIUM]: {
        backgroundColor: theme.palette["orange/100"]?.main,
        labelColor: theme.palette["_components/legend/DPE/orange-foncé"]?.main,
        color: theme.palette["_components/legend/DPE/orange"]?.main,
        label: t(I18N_NAMESPACE, "components.equipmentConditionCount.medium"),
    },
    [EQUIPMENT_CONDITION_GOOD]: {
        backgroundColor: theme.palette["brand logiroad/primary/100"]?.main,
        labelColor: theme.palette["primary"]?.main,
        color: theme.palette["primary"]?.main,
        label: t(I18N_NAMESPACE, "components.equipmentConditionCount.good"),
    },
    [EQUIPMENT_CONDITION_UNKNOWN]: {
        backgroundColor: theme.palette["common/gray_states"]?.main,
        labelColor: theme.palette["common/gray_states"]?.main,
        color: theme.palette["common/gray_states"]?.dark,
        label: "",
    },
})

export const getEquipmentLegendConfig = (t, theme) => {
    const conditions = getEquipmentConditionsValues(t, theme)
    return Object.values(conditions).slice(0, -1)
}